interface Props {
  score: number | null;
  label: string;
  size?: number;
}

const colorFor = (score: number | null): string =>
  score === null ? '#8A94A6' : score >= 80 ? '#16A34A' : score >= 50 ? '#F59E0B' : '#DC2626';

/** Semi-circular score gauge. Mirrors the one used in the PDF report. */
export function ScoreGauge({ score, label, size = 120 }: Props) {
  const radius = 46;
  const circumference = Math.PI * radius;
  const dash = ((score ?? 0) / 100) * circumference;
  const color = colorFor(score);

  return (
    <div className="flex flex-col items-center">
      <svg viewBox="0 0 120 70" width={size} height={size * 0.58} role="img" aria-label={`${label}: ${score ?? 'not measured'}`}>
        <path d="M 14 60 A 46 46 0 0 1 106 60" fill="none" stroke="#E4E8F0" strokeWidth="11" strokeLinecap="round" />
        <path
          d="M 14 60 A 46 46 0 0 1 106 60"
          fill="none"
          stroke={color}
          strokeWidth="11"
          strokeLinecap="round"
          strokeDasharray={`${dash.toFixed(1)} ${circumference.toFixed(1)}`}
          style={{ transition: 'stroke-dasharray .6s ease' }}
        />
        <text x="60" y="56" textAnchor="middle" fontSize="20" fontWeight="800" fill={color}>
          {score === null ? '—' : Math.round(score)}
        </text>
      </svg>
      <span className="mt-1 text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</span>
    </div>
  );
}
